import NewsItem from './NewsItem.vue';

export { NewsItem };
export default NewsItem;
